import * as React from 'react';
import { FlatOptions } from 'ui/common/select/flat-options/flat-options';
import { SelectType } from 'ui/common/select/types';
import { SearchFiltersTranslation } from '../constants';
import { QueryConfigurationProps } from './types';

import styles from './search-attributes.scss';

export const SearchAttributes: React.FC<QueryConfigurationProps & { translation: SearchFiltersTranslation }> = ({
  options, values, hideAttributesLabel, onChangeQueryValue, onSetQueryValues, translation
}) => !!options && options.length > 0 &&
  <div className={`${styles.attributeSelector} ${hideAttributesLabel ? styles.noLabel : ''}`}>
    {!hideAttributesLabel ? <span className={styles.showLabel}>
      {translation.search_on}
    </span> : null}
    <FlatOptions
      options={options}
      valueItems={values}
      showIcons={false}
      selectType={SelectType.multiple}
      onSelectOption={onChangeQueryValue}
      onChange={onSetQueryValues}
      displaySelectAll={false}
    />
  </div>;
